import axios from '@/lib/axios';
import { FixedAsset, Product, PurchaseOrderComment, PurchaseOrderMember } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 0630. 発注案件コメント登録
 * [POST] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/purchase_order_comments
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  content: string;
  content_json: string;
  parent_id?: number;
};
const createPurchaseOrderComment = (props: Props): Promise<PurchaseOrderComment> => {
  return axios.post(`/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/purchase_order_comments`, props);
};

export const useCreatePurchaseOrderComment = () => {
  return useMutation({
    mutationFn: createPurchaseOrderComment,
  });
};
